import React, { useEffect, useState } from "react";
import { SliderWidgetScene } from "@learningblocks/widgets/slider-widget-components";
import i18next from "i18next";
import "./index.css";

import { ColorSpectrum } from "@learningblocks/widgets/lib/widgets.js";

export default function RQuestion(props) {
  const lang = i18next.language;
  const [sceneData, setSceneData] = useState("");
  const [animationData, setAnimationData] = useState("");
  const [mobileAnimationData, setMobileAnimationData] = useState("");
  const [translationData, setTranslationData] = useState("");
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(false);
    fetchData();
  }, [props.data]);

  useEffect(() => {
    if (sceneData !== "" && animationData !== "" && translationData !== "") {
      setReady(true);
    }
  }, [sceneData, animationData, translationData]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    fetch(`${window.CONTENT_BASE_URL}/sliderScene-${props.data.name}.json`
    )
      .then((response) => response.json())
      .then((data) => {
        setSceneData(data);
      });
    fetch(
      `${window.CONTENT_BASE_URL}/locales/${lang}/sliderAnimation-${props.data.name}.json`
    )
      .then((response) => response.json())
      .catch((error) => {
        fetch(
          `${window.CONTENT_BASE_URL}/locales/en/sliderAnimation-${props.data.name}.json`
        )
          .then((response) => response.json())
          .then((data) => {
            setAnimationData(data);
          });
        throw error;
      })
      .then((data) => {
        setAnimationData(data);
      });
    fetch(
      `${window.CONTENT_BASE_URL}/locales/${lang}/sliderAnimation-${props.data.name}_mobile.json`
    )
      .then((response) => response.json())
      .catch((error) => {
        fetch(
          `${window.CONTENT_BASE_URL}/locales/en/sliderAnimation-${props.data.name}_mobile.json`
        )
          .then((response) => response.json())
          .then((data) => {
            setMobileAnimationData(data);
          });
        throw error;
      })
      .then((data) => {
        setMobileAnimationData(data);
      });
    fetch(
      `${window.CONTENT_BASE_URL}/locales/${lang}/sliderTranslation-${props.data.name}.json`
    ) // Should be "lang" instead of ""en"", but lang currently causes a crash because we do not yet create the files needed.
      .then((response) => response.json())
      .catch((error) => {
        fetch(
          `${window.CONTENT_BASE_URL}/locales/en/sliderTranslation-${props.data.name}.json`
        )
          .then((response) => response.json())
          .then((data) => {
            setTranslationData(data);
          });
        throw error;
      })
      .then((data) => {
        setTranslationData(data);
      });
  };

  return (
    <div className="sliderWidget-container">
      {ready === true ? (
        props.data.name === "color-spectrum-ph-indicator-btb" ? (
          <ColorSpectrum
            animationData={animationData}
            sceneData={sceneData}
            whiteBackground={true}
          />
        ) : (
          <SliderWidgetScene
            animationData={animationData}
            mobileAnimationData={
              mobileAnimationData === "" ? null : mobileAnimationData
            }
            sceneData={sceneData}
            stringData={translationData}
            allowOverflow={true}
            path={props.data.name}
            lang={lang}
            standalone={false}
          />
        )
      ) : null}
    </div>
  );
}
